import {
  GET_DASHBOARD_INFO_REQUEST,
  GET_DASHBOARD_INFO_SUCCESS,
  GET_DASHBOARD_INFO_FAILED,
} from './actionTypes';

const initialState = {
  info: null,
  loading: false,
  error: '',
};

const makeStringValues = (obj) => {
  const keys = Object.keys(obj);
  const newObj = {};

  keys.forEach(((k) => {
    newObj[k] = String(obj[k]);
  }));

  return newObj;
};

const dashboardInfo = (state = initialState, {
  type, error, info,
}) => {
  switch (type) {
    case GET_DASHBOARD_INFO_REQUEST:
      return { ...state, loading: true };
    case GET_DASHBOARD_INFO_SUCCESS:
      return {
        ...state,
        info: makeStringValues(info),
        loading: false,
      };
    case GET_DASHBOARD_INFO_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default dashboardInfo;
